<ion-content class="ion-padding">
  <mable-heading
    headingStyle="h3"
    class="no-margin"
    >Rate exceeds NDIS price limits</mable-heading
  >

  <p>Rates above NDIS price limits will be rejected by a NDIS plan manager.</p>
  <p class="ion-no-margin"><strong>Rejected hours will not be paid.</strong></p>

  <p *ngIf="featureFlags.isValidatePriceRateBatchEnabled">
    <strong> Your agreed rates that exceed the NDIS price limits are shown below: </strong>
  </p>

  <div
    *ngFor="let rate of rates"
    class="margin-bottom-2-rem"
  >
    <ng-container *ngIf="featureFlags.isValidatePriceRateBatchEnabled; else legacyPriceLimitInfo">
      <ul>
        <li>
          <p class="ion-no-margin"><strong>Service category:</strong> {{ rate.name }}</p>
          <p class="ion-no-margin"><strong>Day/time:</strong> {{ rate.timeblockName }}</p>
          <p class="red-text ion-no-margin">
            <strong>Your agreed rate:</strong>
            {{ rate.amount | currency: 'AUD' : '$' }} per hour
          </p>
          <p class="ion-no-margin">
            <strong>NDIS max rate:</strong> {{ rate.ndisMaxAmount | currency: 'AUD' : '$' }} per hour
          </p>
        </li>
      </ul>
    </ng-container>

    <ng-template #legacyPriceLimitInfo>
      <p>
        <strong>{{ rate.name }}</strong> - {{ rate.amount | currency: 'AUD' : '$' }} per hour
      </p>
      <p>NDIS max. rate: {{ rate.ndisMaxAmount | currency: 'AUD' : '$' }} per hour</p>
    </ng-template>
  </div>

  <p class="margin-bottom-2-rem">
    <strong>Note:</strong> NDIS max. rates are inclusive of the {{ mableClientFee }} Mable client fee. Rates that exceed
    NDIS price limits may not be eligible for 10-Day Payments and ExpressPay.
  </p>

  <p class="margin-bottom-2-rem">
    On Mable, independent support workers negotiate their rates
    <strong>and typically charge less than maximum NDIS price limits</strong>, to meet client expectations.
  </p>
  <mable-heading
    headingStyle="h4"
    class="no-margin"
  >
    <span [class.red-text]="hasFormValidationBeenChecked && !rateExceedForm.valid"
      >Reason for exceeding NDIS price limit</span
    >
  </mable-heading>
  <form
    [formGroup]="rateExceedForm"
    *ngIf="rateExceedForm"
  >
    <div
      class="error-container"
      *ngIf="hasFormValidationBeenChecked && !this.rateExceedForm.get('rateExceedReasons').valid"
    >
      <ion-icon name="alert-circle"></ion-icon>
      <p>Select a reason to continue with current rates, or edit your rates.</p>
    </div>
    <ion-radio-group formControlName="rateExceedReasons">
      <ion-item
        class="ion-no-padding"
        lines="none"
        *ngFor="let option of EXCEEDED_RATE_REASONS; let index = index"
      >
        <ion-radio
          class="ion-margin-end"
          [value]="option"
          [attr.aria-label]="option.description"
          [attr.data-testid]="'exceed-reason-' + index"
          labelPlacement="end"
          justify="start"
        >
          <p class="ion-text-wrap">
            {{ option.description }}
          </p>
        </ion-radio>
      </ion-item>

      <ion-item
        class="ion-no-padding"
        lines="none"
      >
        <ion-radio
          class="ion-margin-end"
          [value]="EXCEEDED_RATE_OTHER_REASON"
          [attr.aria-label]="EXCEEDED_RATE_OTHER_REASON.description"
          labelPlacement="end"
          justify="start"
        >
          <p class="ion-text-wrap">{{ EXCEEDED_RATE_OTHER_REASON.description }}</p>
        </ion-radio>
      </ion-item>
      <div *ngIf="rateExceedForm.get('rateExceedReasons')?.value?.description === 'Other'">
        <mable-input
          label="Explain your reason"
          [hasError]="hasFormValidationBeenChecked && rateExceedForm.get('otherTextField').errors?.required"
          class="ion-no-margin"
        >
          <ion-textarea
            type="text"
            autocapitalize="sentences"
            rows="4"
            autocomplete="on"
            autocorrect="on"
            spellcheck="true"
            formControlName="otherTextField"
            fill="outline"
            aria-label="Please enter the reason"
          />
          <p class="warn">Please enter the reason.</p>
        </mable-input>
      </div>
    </ion-radio-group>
  </form>

  <mable-button
    expand="block"
    category="link"
    class="ion-no-padding"
    [alignLeft]="true"
    (click)="utilityService.openExternalLink('https://www.ndis.gov.au/media/7150/download?attachment')"
  >
    NDIS Price guide: Remote and very remote areas
  </mable-button>
  <mable-button
    expand="block"
    category="link"
    class="ion-no-padding"
    [alignLeft]="true"
    (click)="openQualtricsForm()"
  >
    Request a non-standard or specialised service
  </mable-button>
</ion-content>

<ion-footer class="ion-padding">
  <mable-button
    data-testid="continue-with-exceed-rates-button"
    expand="block"
    (click)="submit()"
    class="ion-margin-bottom"
    >Continue with current rates</mable-button
  >
  <mable-button
    category="outline"
    expand="block"
    (click)="close()"
    >Edit Rates</mable-button
  >
</ion-footer>
